import { ButtonProps } from "react-aria-components";
import { ReactNode, Ref } from "react";

export enum MDSButtonVariant {
  Default = "default",
  Transparent = "transparent",
  Contrast = "contrast",
  Emphasis = "emphasis",
  EmphasisLight = "emphasis-light",
  Danger = "danger",
  DangerFilled = "danger-filled",
  OnAccent = "onAccent",
  Chrome = "chrome",
  Subtle = "subtle",
  ContrastAccent = "contrast-accent",
}

export enum MDSButtonSize {
  Small = "small",
  Medium = "medium",
  Large = "large",
}

export enum MDSButtonSlotName {
  LeftIcon = "leftIcon",
  RightIcon = "rightIcon",
}

export enum MDSButtonLoadingIndicator {
  Overlay = "overlay",
  Icon = "icon",
}

export interface IMDSButtonProps extends Omit<ButtonProps, "children"> {
  ref?: Ref<HTMLButtonElement>;
  children?: ReactNode;
  variant?: MDSButtonVariant;
  size?: MDSButtonSize;
  isLoading?: boolean;
  loadingIndicator?: MDSButtonLoadingIndicator;
}
